import { Box, Typography, Card, CardContent, Button, CardMedia } from "@mui/material";

export const Trips = () => {
    const trips = [
        {
            name: 'Mont Tremblant, Canada',
            date: 'February 9 – February 14, 2025',
            price: 'CLOSED OUT',
            // link: '',
            image: 'documents/trips/video-winter-tremblant-l.jpg'
        }
    ]

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '20px',
            }}
        >
             <Typography variant="h4" color="text.primary" gutterBottom>
                Trips
            </Typography>

            {trips.map((trip: any, index) => (
                <Card key={index} sx={{ width: '100%', margin: '20px' }}>
                    <CardMedia
                        component="img"
                        height="140"
                        image={trip.image}
                        alt={trip.name}
                    />
                    <CardContent>
                        <Typography variant="h6" color="text.secondary" gutterBottom>
                            {trip.name} | {trip.date} | {trip.price}
                        </Typography>
                        {trip.link && (
                            <Button variant="contained" onClick={() => window.open(trip.link, "_blank")}>
                                Learn More
                            </Button>
                        )}
                    </CardContent>
                </Card>
            ))}
        </Box>
    );
}